import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "../locations";
import { AuthRouter } from "../plugins/auth-router";
import { Modal, ModalProps } from "antd";
import { useAppDispatch } from "../modal/hooks";
import { getAllQueTypeAndWeightage } from "../services/settings/settings.service";

export const Router: React.FunctionComponent = () => {
	Modal.call("", {} as ModalProps);
	return (
		<AuthRouter>
			<div className="h-100">
				<RouterProvider router={router} />
			</div>
		</AuthRouter>
	);
};
